var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.props)?_c('v-chip',{attrs:{"variant":_vm.getColor,"small":"","color":_vm.getColor}},[(_vm.getIcon)?_c('v-icon',[_vm._v(_vm._s(_vm.getIcon))]):[_vm._v(_vm._s(_vm.props.value))]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }